import gql from 'graphql-tag';

export const CHECK_DOWNLOAD_STATUS = gql`
  query download_checkDownloadCsvStatus($downloadId: Id!) {
    download_checkDownloadCsvStatus(downloadId: $downloadId) {
      id
      start
      end
      objectIdList
      status
      createdAt
      link
    }
  }
`;

export const CHECK_DOWNLOAD_STATUS_ONLINE_MEDIA = gql`
  query download_checkDownloadCsvStatusOnlineMedia($downloadId: Id!) {
    download_checkDownloadCsvStatusOnlineMedia(downloadId: $downloadId) {
      id
      start
      end
      mediaList
      phrase
      status
      createdAt
      link
    }
  }
`;

export const CHECK_DOWNLOAD_STATUS_OFFLINE_MEDIA = gql`
  query download_checkDownloadCsvStatusOfflineMedia($downloadId: Id!) {
    download_checkDownloadCsvStatusOfflineMedia(downloadId: $downloadId) {
      id
      start
      end
      mediaList
      phrase
      status
      createdAt
      link
    }
  }
`;

export const GET_SUMMARY_REPORT_STATUS_LIST = gql`
  query Download_getSummaryHistoryReport(
    $projectId: Id!
    $page: Int!
    $limit: Int!
    $name: String
  ) {
    download_getSummaryHistoryReport(
      projectId: $projectId
      page: $page
      limit: $limit
      name: $name
    ) {
      result {
        id
        title
        start
        end
        status
        createdAt
        link
      }
      totalRows
      totalPages
      page
      limit
    }
  }
`;
